
import React, { useState, useEffect } from 'react';
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Crown, ShieldOff } from 'lucide-react';

interface AdminRoleToggleProps {
  userId: string;
  checkAdminStatus: (userId: string) => Promise<boolean>;
  toggleAdminRole: (userId: string, isCurrentlyAdmin: boolean) => void;
}

export const AdminRoleToggle: React.FC<AdminRoleToggleProps> = ({
  userId,
  checkAdminStatus,
  toggleAdminRole
}) => {
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchAdminStatus = async () => {
      try {
        const status = await checkAdminStatus(userId);
        setIsAdmin(status);
      } catch (error) {
        console.error('Error checking admin status:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAdminStatus();
  }, [userId, checkAdminStatus]);

  if (loading) {
    return null;
  }

  return (
    <DropdownMenuItem onClick={() => toggleAdminRole(userId, isAdmin)}>
      {isAdmin ? (
        <>
          <ShieldOff className="h-4 w-4 mr-2" /> Retirer rôle admin
        </>
      ) : (
        <>
          <Crown className="h-4 w-4 mr-2" /> Définir comme admin
        </>
      )}
    </DropdownMenuItem>
  );
};
